import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';
import { KycService } from 'src/app/pages/kyc/kyc.service';
import { SettingsService } from 'src/app/pages/settings/settings.service';
import { ScrollbarComponent } from 'src/app/shared/components/scrollbar/scrollbar.component';
import { AccountInforData } from 'src/app/shared/interfaces/account.interface';
import { LayoutService } from 'src/app/shared/service/layout.service';
import { memberMenu } from '../member-content/member.config';
import { AppService } from './../../app.service';
@UntilDestroy()
@Component({
  selector: 'app-member-layout',
  templateUrl: './member-layout.component.html',
  styleUrls: ['./member-layout.component.scss'],
})
export class MemberLayoutComponent implements OnInit, AfterViewInit {
  constructor(
    private router: Router,
    private appService: AppService,
    public layoutService: LayoutService,
    private kycService: KycService,
    private settingsService: SettingsService
  ) {}

  /** 左侧菜单是否打开 */
  isOpen: boolean = false;

  /** 模板5四大分類選單 */
  memberLayoutMenu: any = [];
  /** 選中index */
  selectInedx = 0;
  /** 選中標題 */
  slelectTitle = '';
  /** 是否為H5 */
  isH5: boolean = true;
  /** 用戶資訊 */
  userInfo?: AccountInforData;
  /** 是否為下午 */
  isEvening: boolean = false;
  currenKycStatus: number = 0; //UI 当前用户kyc状态
  logined: boolean = false;
  isRightAsideOpen: boolean = false;
  @ViewChild('scrollbar') scrollbar!: ScrollbarComponent;

  isOpenCombinePopup!: boolean;
  /** 纪录上一次页面 */
  lastPage: string = '';
  ngOnInit(): void {
    this.checkAMorPM();
    this.layoutService.leftMenuState$.pipe(untilDestroyed(this)).subscribe(isOpen => {
      this.isOpen = isOpen;
    });

    this.layoutService.rightCombinePupup$.pipe(untilDestroyed(this)).subscribe(isOpen => {
      this.isOpenCombinePopup = isOpen;
    });
    this.layoutService.page$.pipe(untilDestroyed(this)).subscribe(page => {
      if (this.lastPage != page) {
        if (this.isH5) {
          this.layoutService.scrollToTop();
        } else {
          this.scrollbar?.scrollToTop();
        }
      }
      this.lastPage = page;
    });
    this.layoutService.isH5$.pipe(untilDestroyed(this)).subscribe(x => {
      this.isH5 = x;
    });
    this.layoutService.scrollToTop$.pipe(untilDestroyed(this)).subscribe(() => {
      if (this.isH5) {
        this.layoutService.scrollToTop();
      } else {
        this.scrollbar?.scrollToTop();
      }
    });

    this.memberLayoutMenu = memberMenu;
    // 因為router寫在 member-content.routing.ts裏面，這邊無法判斷所以要訂閱memberLayoutUrlParam$
    this.layoutService.memberLayoutUrlParam$.pipe(untilDestroyed(this)).subscribe(x => {
      if (x) {
        this.selectInedx = this.memberLayoutMenu.findIndex((y: any) => y.page === x);
        this.selectInedx = this.selectInedx == -1 ? 0 : this.selectInedx;
        this.slelectTitle = this.memberLayoutMenu[this.selectInedx].title;
      }
    });
    this.appService.userInfo$.pipe(untilDestroyed(this)).subscribe(v => {
      this.userInfo = v ?? ({} as any);
      this.logined = !!v;
      if (v) {
        this.checkUserKycStatus(v);
      }
    });

    //订阅当前货币
    // this.appService.currentCurrency$.pipe(untilDestroyed(this)).subscribe(v => {
    //   // this.currentCurrencyData = v;
    //   console.log('currentCurrencyData', v)
    // });
    // this.appService.userBalance$.pipe(untilDestroyed(this)).subscribe(v => {
    //   if (v) {
    //     // this.allCurrencyBalance = v;
    //     this.initData();
    //   }
    // });
  }
  ngAfterViewInit(): void {
    this.layoutService.scrollToTopAnimation$
      .pipe(
        untilDestroyed(this),
        filter(x => x)
      )
      .subscribe(() => {
        if (this.isH5) {
          this.layoutService.scrollToTopAnimation();
        } else {
          this.scrollbar?.scrollToTopAnimation();
        }
      });
  }

  /**
   * 切換菜單
   *
   * @param item
   * @param index
   */
  selectMenu(item: any, index: number) {
    this.selectInedx = index;
    this.slelectTitle = this.memberLayoutMenu[this.selectInedx].title;
    this.router.navigate([this.appService.languageCode, 'member', item.page]);
  }

  /**
   * 登出
   */
  logOut() {
    this.appService.logoutSubject$.next(true);
  }

  /**
   * 跳轉其他頁面
   */
  jumpPage() {
    this.router.navigate([this.appService.languageCode, 'global-settings', 'account', 'kyc']);
    const length = this.kycService.checkUserKycLevel(this.userInfo?.kycGrade || '').level;
    // 如果staus = s 表示成功 所以就到下一個level
    this.appService.kycIndex$.next(length > 2 ? 2 : length);
  }

  /**
   * 判斷是早上還是下午
   */
  checkAMorPM() {
    const hours = new Date().getHours();
    this.isEvening = hours >= 12 ? true : false;
  }

  checkUserKycStatus(userInfo: AccountInforData) {
    this.currenKycStatus = (userInfo?.kycGrade && this.kycService.checkUserKycLevel(userInfo.kycGrade).level) || '';
  }
}
